<template>
  <div class="cl">
    <header-nav :index_num="index_num"></header-nav>
    <div id="excute_box">
      <!--内容-->
      <div class="excute_con">
        <!-- <h3>一、项目申报书</h3>
        <p style="text-indent:1em">
          <a :href="centers.probook ? centers.probook : ''">{{
            probook
              ? probook
              : ""
          }}</a>
          <a :href="centers.probook" target="_blank">{{
            centers.probook.split("/")[8].split(".")[1] == "pdf" ||
            centers.probook.split("/")[8].split(".")[1] == "jpeg" ||
            centers.probook.split("/")[8].split(".")[1] == "png" ||
            centers.probook.split("/")[8].split(".")[1] == "jpg"
              ? "预览"
              : "下载"
          }}</a>
        </p>
        <h3>二、项目实施方案</h3>
        <p style="text-indent:1em">
          <a :href="centers.fangan ? centers.fangan : ''">{{
            fangan
              ? fangan
              : ""
          }}</a>
          <a :href="centers.fangan" target="_blank">{{
            centers.fangan.split("/")[8].split(".")[1] == "pdf" ||
            centers.fangan.split("/")[8].split(".")[1] == "jpeg" ||
            centers.fangan.split("/")[8].split(".")[1] == "png" ||
            centers.fangan.split("/")[8].split(".")[1] == "jpg"
              ? "预览"
              : "下载"
          }}</a>
        </p>
        <h3>三、中期报告</h3>
        <h3>1、基本信息</h3>
        <aside>
          <div style="position: relative; right: 30px">
            <div style="margin-bottom: 15px; position: relative; right: 94px">
              <label style="">项目名称:</label>
            </div>
            <div style="margin-bottom: 15px; position: relative; right: 94px">
              <label style="">机构名称:</label>
              <span style="margin-left: 20px">{{ zDatc.company }}</span>

            </div>
            <div style="margin-bottom: 15px; position: relative; right: 94px">
              <label style="">申请日期:</label>
              <span style="margin-left: 20px">{{ zDatc.aterm }}</span>--<span>{{ zDatc.fterm }}</span>

            </div>
          </div>
        </aside>
        <h3>
          2、中期报告
          <span class="download">
            <span style="margin-left: 15px; margin-right: 5px">
              {{
                dianzi
                  ? dianzi
                  : ""
              }}</span>
            <a :href="centers.elereport" target="_blank">{{
              centers.elereport.split("/")[8].split(".")[1] == "pdf" ||
              centers.elereport.split("/")[8].split(".")[1] == "jpeg" ||
              centers.elereport.split("/")[8].split(".")[1] == "png" ||
              centers.elereport.split("/")[8].split(".")[1] == "jpg"
                ? "预览"
                : "下载"
            }}</a>
          </span>
        </h3>
        <h3>
          四、项目调整申请表及批复意见表

          <span class="download">
            <span style="margin-left: 15px; margin-right: 5px">
              {{
                shenqing
                  ? shenqing
                  : ""
              }}</span> -->
            <!-- <a :href="centers.adjust" download v-if="shenqing">下载 |</a>
            <a :href="centers.adjust" target="_blank" v-if="shenqing">预览</a> -->
            <!-- <a v-if="shenqing" :href="centers.adjust" target="_blank">{{
              centers.adjust.split("/")[8].split(".")[1] == "pdf" ||
              centers.adjust.split("/")[8].split(".")[1] == "jpeg" ||
              centers.adjust.split("/")[8].split(".")[1] == "png" ||
              centers.adjust.split("/")[8].split(".")[1] == "jpg"
                ? "预览"
                : "下载"
            }}</a>
          </span> -->
        <!-- </h3> -->
        <h3>一、中期评审档案资料 : (按照政府购买社会组织服务项目中期评审通知中评审档案要求，整理成PDF文档上传)</h3>
        <p v-if="centers.ziliao == ''" style="color: blue; font-size: 14px">
          暂未上传
        </p>
        <h3 v-for="(i, j) in centers.ziliao" :key="j" v-show="centers.ziliao !== ''">
          <p style="text-indent:1em">活动名称{{ j + 1 }}:{{ i.name }}</p>
          <!-- {{i.elereport.split('/')[8].split('_')}} -->
          <span :href="i.elereport ? i.elereport : ''" style="margin-left: 30px; font-size: 14px; color: #7471ef">{{

              hdmc?hdmc:""
            }}</span>
          <!-- i.elereport
                ? i.elereport.split("/")[8].split("_")[1]
                  ?i.elereport.lastIndexOf("/")+1+
                    "... ." +
                    i.elereport.substr(i.elereport.lastIndexOf(".") + 1)
                  : i.elereport.split("/")[8]
                : "" -->

          <!-- <a :href="i.elereport?i.elereport:''" style="margin-left:-1px">{{i.elereport?(i.elereport.split('/')[8]).split('_')[0]+'.'+i.elereport.substr(i.elereport.lastIndexOf('.')+1):''}}</a>  -->
          <span class="download">
            <a v-if="i.elereport" :href="i.elereport" target="_blank">{{
              i.elereport.split("/")[8].split(".")[1] == "pdf" ||
              i.elereport.split("/")[8].split(".")[1] == "jpeg" ||
              i.elereport.split("/")[8].split(".")[1] == "png" ||
              i.elereport.split("/")[8].split(".")[1] == "jpg"
                ? "预览"
                : "下载"
            }}</a>
          </span>
        </h3>

        <!-- <h3>
          六、政购项目专项资金收支情况表
          <span class="download">
            <span style="margin-left: 15px; margin-right: 5px">
              {{
                midcaiwu
                  ? midcaiwu
                  : ""
              }}</span>

            <a v-if="midcaiwu" :href="centers.budget" target="_blank">{{
              centers.budget.split("/")[8].split(".")[1] == "pdf" ||
              centers.budget.split("/")[8].split(".")[1] == "jpeg" ||
              centers.budget.split("/")[8].split(".")[1] == "png" ||
              centers.budget.split("/")[8].split(".")[1] == "jpg"
                ? "预览"
                : "下载"
            }}</a>
          </span>
        </h3> -->
        <!-- <h3>
          七、其他类
          <span class="download">
            <span style="margin-left: 15px; margin-right: 5px">
              {{
                qita
                  ? qita
                  : ""
              }}</span>

            <a v-if="qita" :href="centers.other" target="_blank">{{
              centers.other.split("/")[8].split(".")[1] == "pdf" ||
              centers.other.split("/")[8].split(".")[1] == "jpeg" ||
              centers.other.split("/")[8].split(".")[1] == "png" ||
              centers.other.split("/")[8].split(".")[1] == "jpg"
                ? "预览"
                : "下载"
            }}</a>
          </span>
        </h3> -->
        <h3>
          二、中期PPT文件
          <span class="download" v-if="ppt">
            <span style="margin-left: 15px; margin-right: 5px">
              {{
                ppt
                  ? ppt.split(".")[0].split("_")[0] + "." + ppt.split(".")[1]
                  : ""
              }}</span>
            <a v-if="ppt" :href="centers.PPT" target="_blank">{{
              centers.PPT.split("/")[8].split(".")[1] == "pdf" ||
              centers.PPT.split("/")[8].split(".")[1] == "jpeg" ||
              centers.PPT.split("/")[8].split(".")[1] == "png" ||
              centers.PPT.split("/")[8].split(".")[1] == "jpg"
                ? "预览"
                : "下载"
            }}</a>
          </span>
          <span v-else style="font-size: 14px; color: blue">暂未上传</span>
        </h3>
      </div>
      <section id="preview" v-if="popupStatus">
        <div class="tc" @click="preview()"></div>
        <section class="tc-text">
          <a v-for="(list, index) in dataFile" :key="index" :href="list.url" target="_blank">{{ list.url }}</a>
        </section>
      </section>
      <section id="popup" v-if="pop" @click="popUp()">
        <aside @click.stop>
          <img :src="linkData" alt />
        </aside>
      </section>
    </div>
    <footer-nav class="footer"></footer-nav>
  </div>
</template>
<script src="https://cdn.staticfile.org/axios/0.18.0/axios.min.js"></script>
<script>
  import HeaderNav from "../../components/HeaderNav";
  import FooterNav from "../../components/FooterNav";
  const path = require("path");
  const files = require.context("@/components", false, /\.vue$/);
  const modules = {};
  files.keys().forEach((key) => {
    const names = path.basename(key, ".vue");
    modules[names] = files(key).default || files(key);
  });
  var preD = function (e) {
    e.preventDefault();
  };
  export default {
    // components: {
    //   HeaderNav,
    //   FooterNav
    // },
    components: modules,
    data() {
      return {
        index_num: 2,
        sub: 0,
        name: " ",
        probook: "",
        fangan: "",
        info: ["1"],
        zDatc: [],
        zDatb: [],
        dataFile: null,
        id: null,
        fileName: null,
        centers: '',
        linkData: "",
        popupStatus: false,
        pop: false,
        informVal: "aaaa",
        goalsVal: "",
        effectVal: "",
        plementVal: "",
        ifupdate: true,
        caiwu: "",
        dianzi: "",
        shenqing: "",
        midcaiwu: "",
        qita: "",
        ppt: "",
      };
    },
    methods: {
      inform(data) {

        this.infomrText = data;
      },
      inform2(data) {

        this.team = data;
      },
      goals(data) {
        this.goalsText = data;
      },
      preview() {
        this.popupStatus = !this.popupStatus;
      },
      effect(data) {
        this.effectText = data;
      },
      plement(data) {
        this.plementText = data;
      },
      aterm() {},
      fterm() {},
      getData() {
        this.$http({
            method: "post",
            url: "v1/project/details",
            data: {
              id: this.id,
            },
          })
          .then((res) => {
            if (res.data.data.code === 200) {
              this.zDatc = res.data.data.data.ProjectDetails;

            } else {
              alert("请求失败！");
            }
          })
          .catch((err) => {
            // // console.log(error);(err);
          });
      },
      getCenter() {
        this.$http({
            method: "get",
            url: "v1/pro/center",
            params: {
              id: this.id,
              category: "center",
            },
          })
          .then((res) => {
            if (res.data.data.code === 200) {
              if (res.data.data.data[0].status == 1000) {
                let data = res.data.data.data[0];
                this.centers = data;
                this.hdmc = this.centers.ziliao[0].elereport
                this.hdmc = this.hdmc.substring(
                  this.hdmc.lastIndexOf("/") + 1
                );
                this.length = this.hdmc.lastIndexOf(".") + 1;
                this.bbbb = this.hdmc.substring(this.length)
                if (this.length > 12) {
                  this.hdmc = this.hdmc.substr(0, 12) + "... ." + this.bbbb
                }
                this.probook = this.centers.probook.substring(
                  this.centers.probook.lastIndexOf("/") + 1
                );
                this.length = this.probook.lastIndexOf(".") + 1;
                this.bbbb = this.probook.substring(this.length)
                if (this.length > 12) {
                  this.probook = this.probook.substr(0, 12) + "... ." + this.bbbb
                }
                this.fangan = this.centers.fangan.substring(
                  this.centers.fangan.lastIndexOf("/") + 1
                );
                this.length = this.fangan.lastIndexOf(".") + 1;
                this.bbbb = this.fangan.substring(this.length)
                if (this.length > 12) {
                  this.fangan = this.fangan.substr(0, 12) + "... ." + this.bbbb
                }
                this.dianzi = this.centers.elereport.substring(
                  this.centers.elereport.lastIndexOf("/") + 1
                );
                this.length = this.dianzi.lastIndexOf(".") + 1;
                this.bbbb = this.dianzi.substring(this.length)
                if (this.length > 12) {
                  this.dianzi = this.dianzi.substr(0, 12) + "... ." + this.bbbb
                }
                this.shenqing = this.centers.adjust.substring(
                  this.centers.adjust.lastIndexOf("/") + 1
                );
                this.length = this.shenqing.lastIndexOf(".") + 1;
                this.bbbb = this.shenqing.substring(this.length)
                if (this.length > 12) {
                  this.shenqing = this.shenqing.substr(0, 12) + "... ." + this.bbbb
                }

                this.midcaiwu = this.centers.budget.substring(
                  this.centers.budget.lastIndexOf("/") + 1
                );
                this.length = this.midcaiwu.lastIndexOf(".") + 1;
                this.bbbb = this.midcaiwu.substring(this.length)
                if (this.length > 12) {
                  this.midcaiwu = this.midcaiwu.substr(0, 12) + "... ." + this.bbbb
                }
                // this.qita = this.centers.other.substring(
                //   this.centers.other.lastIndexOf("/") + 1
                // );
                this.length = this.qita.lastIndexOf(".") + 1;
                this.bbbb = this.qita.substring(this.length)
                if (this.length > 12) {
                  this.qita = this.qita.substr(0, 12) + "... ." + this.bbbb
                }
                if (this.centers.PPT) {
                  this.ppt = this.centers.PPT.substring(
                    this.centers.PPT.lastIndexOf("/") + 1
                  );
                }
              } else {
                this.$message.error("当前页面未提交暂时无法查看！");
                this.$router.push({
                  path: `/schedule${this.id}`
                });
              }
            } else {
              this.$message.error("当前页面未提交暂时无法查看！");
              this.$router.push({
                path: `/schedule${this.id}`
              });
            }
          })
          .catch((err) => {
            // // console.log(error);(err);
          });
      }, //预览
      popUp(link) {

        this.pop = !this.pop;
        this.linkData = link;
      },
    },
    created() {
      this.id = this.$route.query.id;
      this.getData();
      this.getCenter();
    },
  };

</script>
<style lang="scss" scoped>
  .rich {
    margin-bottom: 105px;
  }

  #preview {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0%;
    left: 0%;
    z-index: 999;

    .tc {
      width: 100%;
      height: 100%;
      background-color: rgba($color: #000, $alpha: 0.58);
      position: fixed;
      top: 0%;
      left: 0%;
    }

    .tc-text {
      // width: 350px;
      // width:100%;
      padding: 30px;
      box-sizing: border-box;
      height: auto;
      background-color: #fff;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);

      a {
        display: inline-block;
        margin-top: 10px;
        cursor: pointer;
      }
    }
  }

  #excute_box {
    width: 100%;

    .excute_con {
      width: 1200px;
      margin: 0 auto;
      padding: 50px 30px;
      background: white;
      margin-top: 50px;
      margin-bottom: 50px;

      h3 {
        line-height: 260%;
        font-size: 20px;
      }

      p a {
        line-height: 10%;
        color: #7471ef;
        font-size: 14px;
        margin-right: 10px;
      }

      label {
        margin-left: 16px;
        font-family: "MicrosoftYaHei";
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 25px;
        letter-spacing: 0px;
        color: #333333;
        text-align: right;
        display: inline-block;
        width: 200px;
      }

      input {
        box-sizing: border-box;
        width: 33.8%;
        height: 35px;
        background-color: #ffffff;
        border: solid 1px #c7c7c7;
        outline: none;
        margin-left: 35px;
        margin-bottom: 15px;
        font-family: "MicrosoftYaHei";
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #323232;
        margin-right: 35px;
      }

      .division {
        width: 76%;
      }
      span a {
        color: #7471ef;
      }

      p {
        font-size: 17px;
        color: #666;
        line-height: 30px;
      }

      .download {
        color: #7471ef;
        padding-left: 30px;
        font-size: 14px;
      }
    }
  }

</style>
